import { Injectable } from '@angular/core';
import { ActividadBase } from '@app/shared';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { FormService, ConfigFields } from './form-service';
import { Const } from '@app/shared/util/constants';
import { Actividad } from '@app/shared/models/actividad.model';

export type actionManageActivity = 'create' | 'edit';

@Injectable()
export class ActivityService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta los posibles estados de una actividad ya sea
   * predeterminada o una instancia.
   *
   * @returns {Promise<ActividadBase[]>}
   * @memberof ProcessAutomationService
   */
  getStatusActivity(isInstance: boolean): Promise<ActividadBase[]> {
    const endpoint = isInstance ? 'statusActivity' : 'defaultStatusActivity';
    return new Promise((resolve, reject) => {
      this.http.get<ActividadBase[]>(this.api.get(endpoint)).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }


  /**
   * Consulta los posibles estados de una actividad para utilitarios
   *
   * @return {*}  {Promise<ActividadBase[]>}
   * @memberof ActivityService
   */
  getStatusActivityUtilities(): Promise<ActividadBase[]> {
    return new Promise((resolve, reject) => {
      this.http.get<ActividadBase[]>(this.api.get('statusActivity')).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * actualiza la actividad
   *
   * @param {Actividad} activity
   * @return {*}  {Promise<Actividad>}
   * @memberof ActivityService
   */
  ActivityUpdate(activity: Actividad): Promise<Actividad> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.activity;
    const dataForm = {
      accion:"modificar_datos",
      actividad_id: activity.id,
      datos:{
        estado_id: activity.actividad_estado.id
      }
    };
    return new Promise((resolve, reject) => {
      this.http.post<Actividad>(this.api.addParams(path, 'simple', []), dataForm).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }



  /**
   * Retorna los controles necesarios para crear un formulario dinámico.
   *
   * @param {Partial<ConfigFields>} config
   * @returns
   * @memberof ActivityService
   */
  getControls(config: Partial<ConfigFields>) {
    const fs = new FormService();
    return fs.getFields(config);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/activity/shared/activity.service.ts